{
  "boardmakerHome": "Boardmaker Home",
  "subscription": "Subscription",
  "change": "Change",
  "currency": "USD",
  "save": "Save",
  "save17Percent": "<strong>Save {{percent}}%</strong> with a yearly plan",
  "save17PercentNoBold": "Save {{percent}}%",
  "yearly": "Yearly",
  "monthly": "Monthly",
  "Lifetime": "Lifetime",
  "PerMonth": "Per Month",
  "PerYear": "Per Year",
  "Free": "Free",
  "optional": "optional",
  "trialLengthTrial": "<0>{{ trialLength }}</0>-Day Trial",
  "viewAllPlans": "View All Plans",
  "myBoardmaker": "My Boardmaker",
  "canada": "Canada",
  "unitedStates": "United States",
  "oneMomentPlease": "One moment please...",
  "software": "Software",
  "boardmakerStudio": "Boardmaker Studio",
  "boardmakerStudentCenter": "Boardmaker Student Center",
  "complete": "Complete",
  "loadingRegions": "Loading available regions",
  "loadingPartners": "Loading available partners",
  "supportedPeripherals": "Supported Peripherals",
  "pleaseWait": "Please wait...",
  "minimum": "Minimum",
  "recommended": "Recommended",
  "browser": "Browser",
  "needHelpChoosing": "need help choosing",
  "or": "or",
  "advantages": "Advantages",
  "tobiiDynavoxEyeTrackers": "Tobii Dynavox Eye Trackers",
  "boardmaker7": "Boardmaker 7",
  "visitPartnerSite": "Visit Partner Site",
  "recentOrders": "Recent Orders",
  "current": "current",
  "orLater": "or later",
  "customerSupport": "customer support",
  "proratedAmount": "Prorated amount",
  "community": {
    "community": "Community",
    "getStartedNow": "Get started now!"
  },
  "personal": "Personal",
  "professional": "Professional",
  "planCard": {
    "noCCRequired": "No credit card required",
    "cCOnly": "Credit card only",
    "cCOrPO": "Credit card or purchase order",
    "myPlan": "My Plan",
    "currentPlan": "Current plan",
    "downgradeNotice": "Change takes effect once the current plan expires.",
    "upgradeNotice": "Change takes effect immediately."
  },
  "selectedPlanSummary": {
    "summary": "Summary",
    "change": "$t(change)",
    "subtotal": "Subtotal"
  },
  "action": {
    "joinToday": "Join Today!",
    "finish": "Finish",
    "subscribe": "Subscribe",
    "resubscribe": "Resubscribe",
    "requestAQuote": "Request a Quote",
    "try": "Try",
    "startTrial": "Start Trial",
    "buyNow": "Buy Now",
    "tryIt": "Try it",
    "tryItFree": "Try it free for 30 days!",
    "free": "free",
    "getStarted": "Get Started",
    "forTrialDays": "for <1>{{trialLength}}</1> days",
    "comparePlans": "Compare Plans",
    "hideComparisons": "Hide Comparisons",
    "learnMore": "Learn More",
    "start": "Start",
    "next": "Next",
    "edit": "Edit",
    "cancel": "Cancel",
    "imTaxExempt": "Tax exemption",
    "submit": "Submit",
    "print": "Print",
    "backToPaymentDetails": "Back to payment details",
    "close": "Close",
    "back": "Back",
    "continue": "Continue",
    "uploading": "Uploading",
    "delete": "Delete",
    "update": "Update",
    "generatingInvoice": "Generating invoice",
    "proceed": "Proceed",
    "modify": "Modify",
    "yes": "Yes",
    "signUp": "Sign Up",
    "downloads": "Downloads"
  },
  "status": {
    "loading": "Loading...",
    "creatingAccount": "Creating Account...",
    "submitting": "Submitting...",
    "submittingPayment": "Submitting Payment...",
    "submittingRequest": "Submitting Request...",
    "loadingPaymentForm": "Loading the secure payment form..."
  },
  "planComparison": {
    "label": "What are the feature benefits of each plan?",
    "buttonShow": "$t(action.comparePlans)",
    "buttonHide": "$t(action.hideComparisons)",
    "header": "Feature comparison",
    "subheader": "The world's favorite solution for creating endless symbol-based communication and visual supports!"
  },
  "account": {
    "email": "Email",
    "accountFoundTitle": "Account Found",
    "accountFoundMessage": "An account with this email already exists. Would you like to log in using that account or use a different email and create a new account?",
    "signedOutElsewhereTitle": "You've Been Signed Out",
    "signedOutElsewhereMessage": "You were signed out in another tab. Log in again to continue, or dismiss this to keep browsing without an account.",
    "signedOutElsewhereDismiss": "Continue Browsing",
    "federatedEmailTitle": "Organization Email Detected",
    "federatedEmailMessage": "This email address uses your organization's sign-in. Log in to access Boardmaker through your organization, or use a different email address to create a new account.",
    "federatedEmailUseDifferent": "Use a Different Email",
    "logIn": "Log In",
    "logOut": "Log Out",
    "loggingIn": "Logging in...",
    "loggingOut": "Logging out...",
    "verifying": "Verifying...",
    "loggingInMessage": "Logging you in...",
    "createAccount": "Create Account",
    "creatingAccount": "$t(status.creatingAccount)",
    "login1": "Already have a ",
    "login2": "Tobii Dynavox",
    "login3": "account",
    "loginPrompt": "Already have a <1>Tobii Dynavox account</1>? <3>Log in</3>",
    "cancelSubscription": "Cancel subscription",
    "areYouSure": "Are you sure you want to select this plan? Proceeding will do the following:",
    "cancelSubscriptionProcess": "Cancel the subscription process (your current progress will be lost)",
    "changeToCommunityPlan": "Change your account to a Community plan",
    "onceYouveCompletedYourProfile": "Once you've completed your profile, if you decide to upgrade your plan, you can do so at any time from your My Account section.",
    "proceed": "$t(action.proceed)",
    "back": "$t(action.back)",
    "loadingUser": "Retrieving user information"
  },
  "requestaquote": {
    "fillOutDetailsBelow": "Please fill out the details below and we will have an account manager contact you shortly.",
    "fillOutDetailsBelowLicense": "Please fill out the details below and we will have a sales consultant contact you shortly."
  },
  "forms": {
    "confirmEmail": "Confirm Email",
    "billingDetails": "Billing Details",
    "paymentType": "Payment Type",
    "creditCardType": "Payment Type",
    "creditCard": "Credit Card",
    "purchaseOrder": "Purchase Order",
    "cardNumber": "Card Number",
    "expirationDate": "Expiration Date",
    "cardholderName": "Cardholder Name",
    "cardSecurityCode": "Card Security Code",
    "securityCode": "Security Code",
    "pleaseEnterYourName": "Please enter your name exactly as it appears on the card",
    "needHelpFindingSecurityCode": "Need help finding your card security code",
    "organizationName": "Organization Name",
    "accountsPayableEmail": "Accounts Payable Email",
    "firstName": "First Name",
    "lastName": "Last Name",
    "addressLine": "Address Line 1",
    "addressLine2": "Address Line 2",
    "country": "Country",
    "language": "Language",
    "city": "City",
    "stateProvinceRegion": "State / Province / Region",
    "zipPostalCode": "Zip / Postal Code",
    "month": "Month",
    "year": "Year",
    "optional": "optional",
    "username": "Username",
    "name": "Name",
    "phoneNumber": "Phone Number",
    "phone": "Phone",
    "email": "Email",
    "url": "URL",
    "selectYourCountry": "Select your country",
    "selectYourState": "Select your state",
    "selectYourProvinceTerritory": "Select your province or territory",
    "selectYourTerm": "Select your term",
    "1year": "1 Year",
    "2years": "2 Years",
    "3years": "3 Years",
    "4years": "4 Years",
    "5years": "5 Years",
    "instructorLogins": "Number of Instructor Logins",
    "studentLogins": "Number of Student Logins",
    "term": "Term",
    "tradeIn": "Eligible for a trade discount?",
    "legacyVersions": "Do you have legacy versions of Boardmaker to trade in for a discount off of the cost of Boardmaker?",
    "selectAResponse": "Select a response",
    "yes": "Yes",
    "no": "No",
    "notSure": "Not sure",
    "password": "Password",
    "confirmPassword": "Confirm Password",
    "additionalInformationOrQuestions": "Additional Information or Questions",
    "countryNotSupported": "---",
    "uploadDocument": "Upload Document",
    "chooseFile": "Choose file",
    "paymentMethod": "Payment Method",
    "purchaseOrdersAreOnlyProcessed": "Purchase Orders are only processed once your order is submitted, so they can be modified anytime before that.",
    "PONumber": "Purchase Order Number",
    "PONotes": "Organization Notes",
    "iVerifyThatImAuthorized": "I verify that I'm authorized to submit this purchase order.",
    "submissionSuccessful": "Submission successful!",
    "thankYourForYourRequest": "Thank you for your request! An account manager will contact you shortly.",
    "ccExpDateFormat": "MM/YYYY",
    "numberOfLicenses": "Number of Licenses"
  },
  "validation": {
    "required": "Required",
    "invalidEmail": "Invalid email",
    "emailsMustMatch": "Emails must match",
    "passwordsMustMatch": "Passwords must match",
    "errorOccurred": "An error occurred submitting the form",
    "tryAgain": "Try again. If the problem continues, contact support.",
    "errorOccurredPDF": "An error occured loading the invoice PDF",
    "password": {
      "minLength": "Password must be a minimum of 8 characters",
      "tooShort": "Too Short",
      "checking": "Checking..."
    },
    "invalidCardNumber": "Invalid card number",
    "invalidCardType": "Invalid card type",
    "invalidExpirationDate": "Invalid expiration date",
    "invalidSecurityCode": "Invalid security code",
    "securityCodeNumericWarning": "Security code must container numbers only",
    "invalidUsernameWarning": "Invalid username. Must container only letters and numbers.",
    "usernameMaxLengthWarning": "Username cannot be longer than 60 characters",
    "badZip": "The zipcode entered is not valid for the state selected.",
    "USZipCode": "Must enter a US zip code",
    "CAZipCode": "Must enter a CA postal code.",
    "badPostalCode": "The postal code entered is not valid for the province or territory selected.",
    "canadianAddressNeedsCad": "Canadian billing addresses are billed in Canadian dollars. To continue, select the flag at the top of the page, then choose Canada.",
    "paymentFormError": "The payment form didn't load. Go back and try again.",
    "reenterCard": "We couldn't use that card. Enter your card details again.",
    "cardAddressMismatch": "Your bank couldn't match the billing address. Enter the address exactly as your bank has it, or try a different card.",
    "cardExpired": "This card has expired. Try a different card.",
    "cardDeclined": "Your card was declined. Check the details or try a different card."
  },
  "invoice": {
    "communityHeader": "No credit card. Just free access to the Boardmaker Community. Keep your data and progress if you decide to upgrade to a paid subscription. What are you waiting for?",
    "trialHeader": "No restrictions. No credit card. Keep your data and progress if you decide to convert your trial to a paid subscription. What are you waiting for?",
    "plan": "Plan",
    "term": "Term",
    "price": "Price",
    "billingDetails": "$t(forms.billingDetails)",
    "paymentDetails": "Payment Details",
    "endingWith": "Ending with",
    "expires": "Expires",
    "orderSummary": "Order Summary",
    "orderDate": "Order Date",
    "orderNumber": "Order Number",
    "subtotal": "$t(selectedPlanSummary.subtotal)",
    "tax": "Tax",
    "total": "Total",
    "aConfirmationEmail": "An order confirmation email has been sent to",
    "printOrderSummary": "Print order summary",
    "recurringPaymentDisclaimer": "Your order includes a <strong>recurring payment</strong> in the amount of <3>{{amount}}</3> that will renew <5>{{date, LL}}</5>.",
    "firstPaymentDisclaimer": "We'll charge you <strong>{{amount}}</strong> on <strong>{{date}}</strong>, when your new plan starts.",
    "PODisclaimer": "Your subscription is now active and ready to use. To avoid interruptions in your service, we must receive your payment within <strong>30 days</strong>. If payment is not received by <4>{{date, LL}}</4> , your account will be converted to a free community account until your balance is paid.",
    "purchaseOrderNumber": "Purchase Order Number",
    "orgNotes": "Organization Notes",
    "pleaseSendACopyOfYourInvoice": "Please send your payment and a copy of your invoice to:",
    "ifYourPurchaseOrdersReady": "If your purchase order's ready, you can upload it now.",
    "supportedFileTypes": "Supported file types: .pdf, .jpg, .jpeg, .tif, .tiff, .png",
    "whenTheTimeComes": " When the time comes, we'll send an email to <1>{{email}}</1> reminding you when your next payment is due.",
    "uploadSuccessful": "Upload successful!",
    "yourAccountWillContinue": "Thank you for your purchase order. For subscription renewals, please allow up to 14 days for your order to be processed. When completed, you will receive an email confirming completion along with your invoice.",
    "billing": "Billing address",
    "payment": "Payment method",
    "ifYourPurchaseOrderIsReady": "If your purchase order is ready, you can upload it now.",
    "PODisclaimer1": "Your subscription is now active and ready to use.",
    "PODisclaimer2": "Payment must be received within 30 days or your account will automatically convert to a free community account.",
    "POStartsLaterDisclaimer": "We'll send your invoice on <strong>{{date}}</strong>, when your new plan starts. Payment is due within 30 days of that date."
  },
  "legal": {
    "privacyPolicy": "Privacy Policy",
    "studentPolicy": "Student Data Policy",
    "termsAndConditions": "Terms and Conditions",
    "termsOfService": "Terms of Service",
    "tdTermsAndConditions": "I agree to the Tobii Dynavox <1>$t(legal.termsAndConditions)</1>",
    "contactUs": "Contact Us"
  },
  "errors": {
    "error": "Error",
    "loadingPlans": "Loading plans",
    "sorry": "Sorry... it's not you... it's us",
    "somethingWentWrong": "Something went wrong on our end. We've logged this error and urge you to <1>{{link}}</1> if you encounter this problem again.",
    "tryGoingBack": "Try going back or <1>{{link}}</1>",
    "downloadList": "Could not load the download list."
  },
  "404": {
    "sorry": "Sorry... we couldn't find that page",
    "oldLink": "It might be an old link or it may have moved.",
    "tryGoingBack": "$t(errors.tryGoingBack)"
  },
  "trial": {
    "getStartedNow": "Start your free trial now!",
    "startYourFreeTrial": "Start your free trial",
    "todayWhichIncludesAccessForThirtyDays": " today which includes access for 30 days!"
  },
  "navigation": {
    "bmoRedirect": "Redirecting you to Boardmaker..."
  },
  "expired": {
    "expiredTrialText": "We hope you enjoyed your 30-day unrestricted preview. Your trial has been converted to a free Community plan and all of your data and progress* has been saved. To access the premium features available during your trial, simply upgrade to a monthly or yearly subscription.",
    "dataAndProgress": "* Data and progress contained within premium features, are only accessible with a complete paid subscription."
  },
  "currencySelector": {
    "header": "Select your country and language",
    "disclaimer": {
      "USD": "If your country is not listed, please select United States of America"
    }
  },
  "taxExempt": {
    "us&ca": "United States and Canada only",
    "taxExemptionProgram": "Submit your tax exempt documents using this form. We will contact you by email within 3 business days to confirm your tax exempt status. After you have received the confirmation email, you may place your order tax free. If you place your order before receiving the confirmation email, you will be charged non-refundable tax.",
    "taxExemptionProgramExisting": "Submit your tax exempt documents using this form. We will contact you by email within 3 business days to confirm your tax exempt status. After you have received the approval email, future purchases and subscription renewals will not be taxed. Taxes paid on purchases made prior to receiving the tax exempt confirmation email are non-refundable.",
    "yourSubmissionWasSuccessfulNew": "Your submission was successful. Our staff will review your documentation and you should receive an email notification within 3 business days verifying that your application was processed. Once accepted, you may complete your order tax-free. In the meantime, we've created a free Community account for you, to begin exploring all Boardmaker has to offer.",
    "yourSubmissionWasSuccessfulExisting": "Your submission was successful. Our staff will review your documentation and you should receive an email notification within 3 business days verifying that your application was processed. Once accepted, you may complete your next payment tax-free."
  },
  "modify": {
    "contactCustomerSupport": "Contact <1>{{supportLink}}</1> to modify your subscription",
    "billingDetails": "Modify billing details",
    "paymentModalHeader": "Update successful!",
    "paymentModalBody": "Your changes will be reflected on your next billing cycle.",
    "thankYou": "Thank you for your payment!",
    "daysRemaining": "days remaining",
    "dueDisclaimer": "If payment is not received within 30 days of your renewal date, your account will automatically convert to a free community account until your balance is paid.",
    "lateDisclaimer": "To avoid interruption to your subscription, please pay your balance in full. If payment is not received, your account will automatically convert to a free community account until your balance is paid.",
    "nextPaymentDueIn": "Next payment due in",
    "days": "days",
    "paymentIs": "Payment is",
    "daysPastDue": "days past due",
    "recurringPaymentDisclaimer": "Your <1>planOrOrder</1> includes a <strong>recurring payment</strong> in the amount of <4>{{amount}}</4> that will renew <7>{{date, LL}}</7>.",
    "recurringPaymentDisclaimerNoPrice": "Your plan includes a <strong>recurring payment</strong> that will renew <3>{{date, LL}}</3>.",
    "pastDueDisclaimer": "You may submit your purchase order using one of the methods described below. Please contact our customer support team to reactivate your subscription.",
    "yourAccountHasBeenConverted": "Your paid account is converted to a free community account",
    "balanceDueIn": "Balance due in",
    "subscriptionExpiresIn": "Subscription expires in",
    "paymentPastDue": "Payment past due",
    "autoRenewal": "Auto-Renewal",
    "turnAutoRenewOff": {
      "header": "Disable subscription auto-renewal",
      "areYouSure": "Are you sure you want to turn off auto-renewal? Proceeding will do the following:",
      "points": [
        "Cancel your paid subscription at the end of your current billing cycle.",
        "Convert your account to a free Community plan at the end of your current billing cycle.",
        "You will have access to your content after the conversion and you can subscribe again at any time to regain access to the premium features that come with paid subscriptions. ",
        "If you change your mind before your current subscription ends, simply turn auto-renewal on again."
      ],
      "footer": "Would you like to disable auto-renewal?"
    },
    "turnAutoRenewOn": {
      "header": "Enable subscription auto-renewal",
      "areYouSure": "Automatic subscription renewal features:",
      "points": [
        "Your subscription is set to renew automatically when the current subscription period ends.",
        "Hassle-free payment using your stored payment method.",
        "We email you a receipt each time your subscription renews.",
        "As always, you can change your subscription settings at any time in My plan details.",
        "Change your mind? Disable auto-renewal before the end of the last day of the current subscription period and you won't be billed."
      ],
      "footer": "Would you like to enable auto-renewal?"
    },
    "on": "On",
    "off": "Off",
    "pending": "pending",
    "plan": "Plan",
    "term": "Term",
    "effective": "Effective",
    "subscription": "Subscription",
    "downgradeWarning": {
      "title": "Downgrade Subscription",
      "prompt": "Are you sure you want to select this plan? Proceeding will do the following:",
      "planChange": "Downgrade your plan from Professional to Personal at the end of your current billing cycle",
      "termChange": "Downgrade your term from Yearly to Monthly at the end of your current billing cycle",
      "changeNote": "Your changes will be reflected on your next billing cycle.",
      "termChangeMultiToYearly": "Downgrade your multi-year term to a Yearly term at the end of your current billing cycle",
      "termChangeMultiToMonthly": "Downgrade your multi-year term to a Monthly term at the end of your current billing cycle"
    },
    "futureAmendmentThankYou": "These changes will take effect at the end of the current billing cycle. An invoice will be available once these changes are applied to your account. If you wish to cancel a pending change, please call <1>customer support</1>.",
    "futureAmendmentDisclaimer": "Your current <1>{{planName}}</1> plan will expire on <3>{{startEndDate}}</3>. Your new <5>{{selectedPlanName}}</5> plan will start on <7>{{startEndDate}}</7> and auto-renew <9>{{term}}</9>.",
    "modificationPending": "Plan modification pending",
    "paymentDeclined": "Your subscription renewal transaction was declined. Please modify your payment method by <1>{{date}}</1> or your subscription will be canceled.",
    "continueSubscription": "Your subscription will end on <1>{{ date1 }}</1>. If you would like to continue your subscription for another {{term}}, turn on Auto-Renewal by <5>{{ date2 }}</5> and we will process your payment the following day.",
    "discontinuedRatePlan": "Your current subscription plan is no longer available. Please choose another option.",
    "cancelYourSubscription": "If you wish to cancel your subscription and receive a full refund, you must contact <1>{{supportLink}}</1> before <3>{{thirtyDayWindow}}</3>",
    "modifySubscription": "Modify subscription",
    "cancelCardText": "You can cancel your subscription at any time. But we would love for you to stay.",
    "cancelConfirmTitle": "Are you sure you want to cancel your subscription?",
    "cancelConfirmIntro": "Your current plan will remain active until <strong>{{date}}</strong>. After your plan ends, you will:",
    "cancelConsequences": [
      "Lose access to premium features.",
      "Miss out on exclusive benefits available with your subscription.",
      "Lose your subscription benefits when your current plan expires."
    ],
    "keepSubscription": "Keep my subscription",
    "confirmCancel": "No, I want to cancel",
    "cancelledTitle": "Your subscription has been cancelled!",
    "cancelledBody": "Your subscription has been cancelled. You'll not have access to your premium account after {{date}}.",
    "cancelledFarewell": "We're sorry to see you go! You're always welcome to come back.",
    "done": "Done",
    "cancelledNotice": "Your current <strong>{{planName}}</strong> subscription will expire on <strong>{{date}}</strong>. Renew your subscription to continue enjoying our premium features.",
    "resubscribedNotice": "Your new <strong>{{planName}}</strong> subscription starts on <strong>{{date}}</strong>, when your current one ends."
  },
  "tdAccount": {
    "title": "Tobii Dynavox Account",
    "header": "What's a Tobii Dynavox Single Sign On (SSO) account?",
    "body": "Your Tobii Dynavox SSO account, comprised of an email address and password, is your one account for logging into any of our websites or apps. Along with improved security benefits, SSO provides faster and more convenient access to your content across all Tobii Dynavox services.",
    "haveA": "Have a",
    "tobiiDynavoxAccount": "Tobii Dynavox account?"
  },
  "redirectPageTitle": {
    "homePage": "Home Page",
    "profileCreation": "Profile Creation"
  },
  "download": {
    "downloadBoardmaker": "Download Boardmaker",
    "downloadBoardmakerStudentCenter": "Download Boardmaker Student Center",
    "downloadOtherVersions": "Download other versions",
    "downloadBoardmakerStudio": "Download Boardmaker Studio",
    "downloadSystemRequirements": "system requirements",
    "latestMobile": "For the best experience, please try downloading the software from a device that meets the <1>{{systemRequirements}}</1>.",
    "licenseKey": "License Key",
    "onThisPage": "On this page",
    "download": "Download",
    "licenseHelper": "License Helper",
    "discontinued": "Discontinued <1>{{discontinueDate}}</1>. See <3>system requirements</3>.",
    "communityStart": {
      "header": "Claim your Community access and storage",
      "body": "Boardmaker is designed to work with myboardmaker.com. Your free Boardmaker Community account includes:",
      "pointOne": "Cloud storage - securely back up your personal Boardmaker files and access them anywhere!",
      "pointTwo": "Activities-to-Go - Leveled, thematic curriculum that's ready to print and use.",
      "pointThree": "Access to our global Community - share what you have created and find new Boardmaker activities from other users.",
      "footer": "Sign up for your free Community account to gain access!"
    },
    "viewSystemRequirements": "View the <1>{{guideLink}}</1> for system requirements.",
    "mainFeatures": "Main Features",
    "compatibility": "Compatibility",
    "improvements": "Improvements",
    "bugFixes": "Bug fixes",
    "version": "Version",
    "discontinuedSupport": "Discontinued support",
    "BoardmakerCompatible": "This device is not compatible with Boardmaker software.",
    "BoardmakerStudentCenterCompatible": "This device is not compatible with the Boardmaker Student Center Application.",
    "BoardmakerMobile": "Boardmaker applications are not supported on this device.",
    "releaseDate": "Released {{date}}",
    "discontinuedDate": "Discontinued {{date}}",
    "boardmakerSummary": "Select the button below to download the latest version of the Boardmaker Editor, which is used for creating and editing activities.  The installer works for all account types and supported languages.",
    "studentCenterSummary": "Select the button below to download the latest version of the Boardmaker Student Center, which is used for playing Boardmaker activities. The installer works for all account types and supported languages.",
    "boardmakerIntro": "Boardmaker 7 Editor is the premier tool to help educators, therapists, and parents create, edit, and share Boardmaker activities.  Support learning and communication in your classroom, therapy room, or home with a trove of customizable material.",
    "studentCenterIntro": "When paired with certain types of Boardmaker 7 subscriptions, teachers can assign activities to students in the Boardmaker 7 Student Center app and track their progress.  Students can use the app at home or school to complete their activities.",
    "boardmakerStudioIntro": "Boardmaker Studio allows people who support students with disabilities to create and edit activities to help students learn and communicate using symbols, text, and synthetic and recorded speech.",
    "mobilePlayerIntro": "When paired with certain types of myBoardmaker subscriptions, teachers can assign activities to students in the Boardmaker Student Center app and track their progress.  Students can use the app at home or school to complete their activities."
  },
  "subscriptionLicense": {
    "toggle": {
      "subscription": "subscription",
      "tosubscriptionText": "$t(subscriptionLicense.toggle.subscription)",
      "license": "license",
      "tolicenseText": "one-time purchase",
      "mainText": "Prefer a <1>{{ toggleText }}</1> or <3>{{ helpLink }}</3>?",
      "preferencedText": "Prefer a "
    },
    "comparison": {
      "accessTo": "Access to the following...",
      "title": "Help me choose",
      "titleDescription": "A quick look at the differences between a Boardmaker Subscription and the Boardmaker Software by itself.",
      "titles": {
        "investment": "Investment",
        "includedSoftware": "Included Software",
        "softwareUpdates": "Software Updates",
        "pcsSymbols": "PCS Symbols",
        "cloudStorage": "Cloud Storage",
        "curriculum": "Curriculum",
        "studentManagement": "Student Management"
      },
      "subscription": {
        "header": "Boardmaker Subscription",
        "investment": "Low up-front cost, annual or monthly payment options",
        "includedSoftware": "Boardmaker 7, Boardmaker Student Center",
        "softwareUpdates": "Included (2-3 times a year)",
        "pcsSymbols": "All symbols, including new symbols every 2 weeks",
        "cloudStorage": ["Activity storage", "Media Storage"],
        "curriculum": [
          "Boardmaker Activities to Go 10 Themes x 4 Units each",
          "Core First Communication Book",
          "Reading Avenue\u00B2",
          "Core First Learning\u00B2",
          "Expedition Education\u00B2",
          "Book Bridge\u00B2"
        ],
        "studentManagement": ["Assign activities\u00B3", "Track performance"]
      },
      "license": {
        "header": "Software Only",
        "investment": "One-time purchase of software",
        "includedSoftware": "Boardmaker 7",
        "softwareUpdates": "Paid upgrades periodically (every 2-3 years)",
        "pcsSymbols": "All symbols available at the time of last release (PCS subscription coming soon)",
        "cloudStorage": ["Activity storage\u00B9"],
        "curriculum": [
          "Boardmaker Activities to Go 1 Theme x 4 Units\u00B9",
          "Core First Communication Book"
        ],
        "studentManagement": ["None"]
      },
      "note": "Available with a Community Account",
      "note2": "Can only be accessed with Student Center Player",
      "note3": "Users can manage and add assignments to individual students in the Professional subscription plan",
      "localizationNoteOne": "The Boardmaker 7 apps are available in the following languages for both subscription and perpetual (software-only) users",
      "availableIn": [
        "Dansk",
        "Deutsch",
        "English (US)",
        "Español",
        "Suomi",
        "Français",
        "Italiano",
        "Norsk",
        "Polski",
        "Português (Brasil)",
        "Русский",
        "Svenska"
      ],
      "oldAvailableIn": [
        "Spanish",
        "German",
        "Swedish",
        "Finnish",
        "Russian",
        "Danish",
        "Norwegian",
        "French",
        "Italian",
        "Polish",
        "Portuguese"
      ],
      "localizationNoteTwo": "The curriculum and myBoardmaker.com website are only available in English."
    }
  },
  "systemRequirements": "System Requirements",
  "releaseNotes": "Release Notes",  
  "operatingSystem": {
    "title": "Operating System",
    "macos": "macOS",
    "chromebook": "Chromebook",
    "ios": "iPadOS",
    "android": "Android (mobile)",
    "windows": "Windows",
    "unknown": "Unknown"
  },
  "perpetual": {
    "trial": {
      "intro": "No credit card. No commitment. Just <1>{{trialLength}}</1> consecutive days of unrestricted access to our latest Boardmaker software. After downloading and installing the software onto your computer, you can request a <3>{{trialLength}}</3>-day activation key<5>*</5> from within the software.",
      "footnote": "<0>*</0>Trials start the day our software is activated and will remain active for <2>{{trialLength}}</2> consecutive days.",
      "downloadFootnote": "<0>v{{version}}</0> includes the latest features and fixes. See <2>system requirements</2>."
    },
    "thankyou": {
      "intro": "Look for your order confirmation email containing the Boardmaker download links and your activation key. We've also provided the information below. Download and install Boardmaker onto your computer, then use the activation key to activate your software. <1>Be sure to save your activation key for future use.</1>"
    },
    "latest": "Latest",
    "legacy": "Legacy"
  },
  "countries": {
    "us": "United States of America"
  },
  "currencyChange": {
    "header": "Currency change",
    "body": "At this time, Subscriptions cannot be purchased using the currency from your selected country. Proceeding will change your currency to United States dollars - USD."
  },
  "partner": {
    "body": "The chosen partner, or support supplier, will be your primary contact for all product related questions and technical issues.",
    "contactUs": "If the country listed is not correct, please ",
    "contactCustomerService": "contact customer service."
  }
}
